import { render, staticRenderFns } from "./investigating.vue?vue&type=template&id=9b27a7d8&scoped=true&"
import script from "./investigating.vue?vue&type=script&lang=js&"
export * from "./investigating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b27a7d8",
  null
  
)

export default component.exports